import type { InferOutput, ObjectEntries, ObjectSchema } from 'valibot'
import { parse } from 'valibot'

/**
 * Convert a form submission event to JSON. If a schema is provided, the result will be validated and typed accordingly.
 *
 * @param event - The form submission event.
 * @param schema - Optional Valibot schema to validate and type the result.
 */
export function jsonFromForm(event: Event, schema?: never): Record<string, FormDataEntryValue>
export function jsonFromForm<TEntries extends ObjectEntries, TSchema extends ObjectSchema<TEntries, any>>(event: Event, schema: TSchema): InferOutput<TSchema>
export function jsonFromForm<TEntries extends ObjectEntries, TSchema extends ObjectSchema<TEntries, any>>(event: Event, schema?: TSchema): Record<string, FormDataEntryValue> | InferOutput<TSchema> {
  const formData = new FormData(event.target as HTMLFormElement)

  const entries = Object.fromEntries(formData)

  if (schema) {
    return parse(schema, entries)
  }

  return entries
}
